import React, { useEffect, useState } from 'react'
import "../../styles/profileStyles/myProfileFollows.css";
import { useParams } from 'react-router-dom';
import BeatLoader from 'react-spinners/BeatLoader';

export default function MyProfileFollows() {
    const [cardDatas, setCardDatas] = useState(null);
    const [showContent, setShowContent] = useState("followers");

    const { username: targetUsername } = useParams();

    // const cardDatas = {
    //     success: true,

    //     stats: {
    //         following: 3,
    //         followers: 5
    //     },

    //     following: [
    //         {
    //             id: 1,
    //             username: "Tippmester123",
    //             profile_picture: "https://focifanatik.hu/favicon.ico",
    //             followers: 50,
    //             successRate: 62
    //         },
    //         {
    //             id: 2,
    //             username: "NagyonHosszuFelhasznalonevTeszt",
    //             profile_picture: "https://focifanatik.hu/favicon.ico",
    //             followers: 120,
    //             successRate: 48
    //         },
    //         {
    //             id: 3,
    //             username: "ProTipper",
    //             profile_picture: "https://focifanatik.hu/favicon.ico",
    //             followers: 300,
    //             successRate: 75
    //         }
    //     ],

    //     followers: [
    //         {
    //             id: 4,
    //             username: "UserOne",
    //             profile_picture: "https://focifanatik.hu/favicon.ico",
    //             followers: 20,
    //             successRate: 25
    //         },
    //         {
    //             id: 5,
    //             username: "AnotherUser",
    //             profile_picture: "https://focifanatik.hu/favicon.ico",
    //             followers: 80,
    //             successRate: 55
    //         },
    //         {
    //             id: 6,
    //             username: "FootballKing",
    //             profile_picture: "https://focifanatik.hu/favicon.ico",
    //             followers: 150,
    //             successRate: 68
    //         }, 
    //         {
    //             id: 7,
    //             username: "FootballKing2",
    //             profile_picture: "https://focifanatik.hu/favicon.ico",
    //             followers: 150,
    //             successRate: 68
    //         }
    //     ]
    // };


    useEffect(() => {
        fetch(`https://focifanatik.hu/api/profile_API/profileFollows.php?username=${targetUsername}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    setCardDatas(data);
                }
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, [targetUsername]);

    if (!cardDatas) {
        return (
            <>
                <div className='loading-bg-profileBar'><BeatLoader color="white" size={55} /></div>
                <div className='loading-bg-content'></div>
            </>
        );
    }

    return (
        <>

            <div className='myProfileFollowsPage-topProfileBar'>

                <h1><i class="bi bi-bookmarks"></i></h1>
                <h1>Követések</h1>

            </div>

            {/* TARTALOM */}
            <div className='myProfileFollowsPage-content'>

                <div className='myProfileFollowsPage-headerFollows'>

                    <div className='myProfileFollowsPage-headerFollows-item'>

                        <button onClick={() => setShowContent("following")}>Követéseim</button>
                        <p>{cardDatas.stats.following}</p>

                    </div>

                    <div className='myProfileFollowsPage-headerFollows-item'>

                        <button onClick={() => setShowContent("followers")}>Követőim</button>
                        <p>{cardDatas.stats.followers}</p>

                    </div>



                </div>
                <div className='myProfileFollowsPage-headerSearch'>

                    <input type="text" placeholder='Irj be egy nevet a kereséshez...' />

                </div>

                <div className='myProfileFollowsStatsGrid'>

                    {/* --------------------------------------- KÖVETŐK VAGY KÖVETÉSEK KÁRTYA JELENJEN MEG ----------------------------------- */}
                    {showContent === "followers" && (
                        cardDatas.followers.map((followers) => (
                            <div className='myProfileFollowsCard' key={followers.id}>

                                <div className='myProfileFollowsCard-image'>
                                    <img src={followers.profile_picture} alt="" />
                                </div>

                                <div className='myProfileFollowsCard-details'>
                                    <div><span>{followers.username}</span></div>
                                    <div><span>{followers.followers} követő | Találati arány: {followers.successRate}%</span></div>
                                </div>

                                <div className='myProfileFollowsCard-FollowButton'>
                                    <button>Követés</button>
                                </div>

                            </div>
                        ))
                    )}
                    {showContent === "following" && (
                        cardDatas.following.map((following) => (
                            <div className='myProfileFollowsCard' key={following.id}>

                                <div className='myProfileFollowsCard-image'>
                                    <img src={following.profile_picture} alt="" />
                                </div>

                                <div className='myProfileFollowsCard-details'>
                                    <div><span>{following.username}</span></div>
                                    <div><span>{following.followers} követő | Találati arány: {following.successRate}%</span></div>
                                </div>

                                <div className='myProfileFollowsCard-FollowButton'>
                                    <button>Követés</button>
                                </div>

                            </div>
                        ))
                    )}


                </div>
            </div>
        </>
    )
}
